import React from 'react';
import { classNames } from './classNames';

export interface DropdownItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

const DropdownItem = React.forwardRef<HTMLButtonElement, DropdownItemProps>(({
  active = false,
  type = 'button',
  className,
  children,
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    className={classNames('dropdown-item', active ? 'active' : undefined, className)}
    {...props}
  >
    {children}
  </button>
));

DropdownItem.displayName = 'DropdownItem';

export default DropdownItem;
